import { createIds } from 'helpers/idHelpers';

const getIds = (root: string) => {
  return createIds(root, 'nft');
};

export default getIds;
